module.exports = __webpack_public_path__ + "ef6556c4b58c8fd5ddf71610712b210e.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./~/ace-builds/src-noconflict/snippets/golang.js
// module id = 1574
// module chunks = 0